export default ['JsonRPCService', (JsonRPCService) => {
    return {
        removeDocument: (serviceRequestID, publicID) => {
            return JsonRPCService.send('cc', 'servicerequest/docs', 'removeDocument', [serviceRequestID, publicID]);
        }
    };
}];